module.exports = "<navbar></navbar>\n<h1>{{ vm.name }}</h1>\n<section>\n  About us.\n</section>\n"


//////////////////
// WEBPACK FOOTER
// ./app/components/about/about.html
// module id = 290
// module chunks = 1